"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var isValidClause_1 = require("../utils/isValidClause");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(function isInboxRuleEditDirty(state) {
    return (state.optionState.inboxRulesEditState.clauseMap.size > 0 &&
        state.optionState.inboxRulesEditState.ruleName.trim().length > 0 &&
        isValidClause_1.isValidSection('conditional') &&
        isValidClause_1.isValidSection('action') &&
        isValidClause_1.isValidSection('exception'));
});
//# sourceMappingURL=isInboxRuleEditDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/utils/isInboxRuleEditDirty.js
// module id = 5228
// module chunks = 2